import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=50b3ef5e&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b3ef5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50b3ef5e')) {
      api.createRecord('50b3ef5e', component.options)
    } else {
      api.reload('50b3ef5e', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=50b3ef5e&scoped=true&", function () {
      api.rerender('50b3ef5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2fOmTngycpimz/JS/comp/Accordion.vue"
export default component.exports